export default "__VITE_ASSET__COnFd8hJ__"